import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, Menu, X, MapPin, LayoutDashboard } from 'lucide-react';
import { useCidade } from '../context/CidadeContext';
import { useAuth } from '../context/AuthContext';
import { SeletorCidade } from './SeletorCidade';

export function Header() {
  const { cidade, setCidade } = useCidade();
  const { isProfissional, isAnunciante, user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSeletor, setShowSeletor] = useState(false);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (search.trim()) params.set('q', search.trim());
    if (cidade) { params.set('cidade', cidade.nome); params.set('estado', cidade.uf); }
    navigate(`/buscar${params.toString() ? '?' + params.toString() : ''}`);
    setMenuOpen(false);
  };

  return (
    <>
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-xl border-b border-gray-100 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0" data-testid="logo-link">
            <div className="w-8 h-8 bg-[#1D9E75] rounded-xl flex items-center justify-center shadow-sm">
              <span className="text-white font-bold text-sm">G</span>
            </div>
            <span className="font-bold text-[#085041] text-lg" style={{ fontFamily: "'Work Sans', sans-serif" }}>GuiaCit</span>
          </Link>

          <nav className="hidden md:flex items-center gap-5">
            <Link to="/buscar" className="text-sm text-gray-600 hover:text-[#1D9E75] transition-colors font-medium">
              Buscar profissionais
            </Link>
            <button
              onClick={() => setShowSeletor(true)}
              className="flex items-center gap-1.5 text-sm font-medium px-3 py-1.5 rounded-full border transition-colors"
              style={cidade ? { color: '#1D9E75', background: '#E1F5EE', borderColor: '#9FE1CB' } : { color: '#6b7280', background: '#f9fafb', borderColor: '#e5e7eb' }}
              data-testid="cidade-badge"
            >
              <MapPin size={13} />
              {cidade ? cidade.nome : 'Selecionar cidade'}
            </button>
            <Link to="/entrar" className="text-sm text-gray-600 hover:text-gray-900 font-medium">Entrar</Link>
            {isAnunciante ? (
              <Link to="/anunciante/dashboard" data-testid="header-anunc-dashboard-btn" className="text-sm text-[#1D9E75] hover:text-[#178460] font-semibold">Painel anunciante</Link>
            ) : (
              <Link to="/anunciante/entrar" className="text-sm text-gray-600 hover:text-gray-900 font-medium">Anunciar</Link>
            )}
            {isProfissional ? (
              <Link to="/dashboard" data-testid="header-dashboard-btn" className="btn-primary text-sm py-2 px-4 flex items-center gap-1.5">
                <LayoutDashboard size={14} /> Meu painel
              </Link>
            ) : (
              <Link to="/cadastro" className="btn-primary text-sm py-2 px-4" data-testid="header-cadastro-btn">
                Cadastrar profissional
              </Link>
            )}
          </nav>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Menu"
            data-testid="mobile-menu-btn"
          >
            {menuOpen ? <X size={20} className="text-gray-600" /> : <Menu size={20} className="text-gray-600" />}
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-1 shadow-lg">
            <form onSubmit={handleSearch} className="flex gap-2 mb-3">
              <div className="relative flex-1">
                <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar profissional..." className="input pl-8 py-2 text-sm" />
              </div>
              <button type="submit" className="btn-primary py-2 px-4 text-sm">Ir</button>
            </form>
            <button onClick={() => { setShowSeletor(true); setMenuOpen(false); }} className="w-full flex items-center gap-2 py-2.5 text-sm text-gray-700 hover:text-[#1D9E75]">
              <MapPin size={14} className="text-[#1D9E75]" />
              {cidade ? `${cidade.nome}/${cidade.uf}` : 'Selecionar cidade'}
            </button>
            <Link to="/buscar" onClick={() => setMenuOpen(false)} className="block py-2.5 text-sm text-gray-700 hover:text-[#1D9E75] font-medium">Buscar profissionais</Link>
            {isProfissional ? (
              <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="block py-2.5 text-sm text-[#1D9E75] font-semibold">
                Meu painel — {user?.nome?.split(' ')[0]}
              </Link>
            ) : (
              <Link to="/entrar" onClick={() => setMenuOpen(false)} className="block py-2.5 text-sm text-gray-700 hover:text-[#1D9E75]">Entrar</Link>
            )}
            <Link to={isAnunciante ? '/anunciante/dashboard' : '/anunciante/entrar'} onClick={() => setMenuOpen(false)} className="block py-2.5 text-sm text-gray-700 hover:text-[#1D9E75]">{isAnunciante ? 'Painel do anunciante' : 'Anunciar minha empresa'}</Link>
            {!isProfissional && (
              <div className="pt-2">
                <Link to="/cadastro" onClick={() => setMenuOpen(false)} className="btn-primary text-sm w-full block text-center">
                  Cadastrar profissional
                </Link>
              </div>
            )}
          </div>
        )}
      </header>

      {showSeletor && <SeletorCidade onClose={() => setShowSeletor(false)} />}
    </>
  );
}
